module.exports = __webpack_public_path__ + "static/media/online-lesson.4d8cafc0.svg";